import React from 'react'

const AudienceSuccessItem = (props: {
  name: string
  values: Array<string>
}): JSX.Element => {
  const { name, values } = props
  return (
    <div className={'pt-10 flex justify-between border-b-2 pb-5'}>
      <div className={'font-bold text-sm'}>{name}</div>
      <div className={'flex flex-row flex-wrap w-1/2 justify-end gap-3'}>
        {values.map((value: string, index: number) => {
          return (
            <div key={index} className={`px-4 py-2 bg-gray-100 font-medium text-xs`}>
              {value}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AudienceSuccessItem
